/** Google AdSense 퍼블리셔 ID */
export const ADSENSE_CLIENT = 'ca-pub-6891075474674049';

/**
 * 디스플레이 광고 단위 슬롯 ID
 * AdSense 콘솔 > 광고 > 광고 단위 에서 생성 후 .env에 입력
 */
export const ADSENSE_SLOTS = {
  /** 전 페이지 푸터 상단 반응형 배너 */
  banner: process.env.REACT_APP_ADSENSE_SLOT_BANNER ?? '',
  /** 메인 중간 반응형 배너 */
  inArticle: process.env.REACT_APP_ADSENSE_SLOT_INARTICLE ?? '',
} as const;
